import React, { useMemo, useState } from "react";
import { Card, CardBody, Col, Container, Input, Label, Row } from "reactstrap";
import DataTable from "react-data-table-component";
import { StyleSheetManager } from "styled-components";
import { AddProduct, ECommerce, ProductList, SearchButton } from "../../../../constants";
import { ProductTableLists, ProductTableListHead } from "../../../../data/applications/ECommerce";
import FilterCollapse from "./FilterCollapse";
import TopLinks from "./TopLinks";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

// This component displays a list of products with filtering, searching, and toggleable views.
const ProductListContainer = () => {

  const [filterText, setFilterText] = useState("");
  const [showList, setShowList] = useState(false);
  const filteredItems = ProductTableLists.filter((item) => Object.values(item).some((value) => value && value.toString().toLowerCase().includes(filterText.toLowerCase())));

  // Memoized search input component to avoid unnecessary re-renders
  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="dataTables_filter d-flex align-items-center">
        <Label className="me-2">{SearchButton}:</Label>
        <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type="search" value={filterText} />
      </div>
    );
  }, [filterText]);

  return (
    <>
      <Breadcrumbs mainTitle={ProductList} parent={ECommerce} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="list-product-header">
                  <TopLinks buttonName={AddProduct} setShowList={setShowList} showList={showList} />
                  <FilterCollapse showList={showList} />
                </div>
                <div className="list-product">
                  <div className="table-responsive">
                    <StyleSheetManager shouldForwardProp={(prop) => prop !== "align" && prop !== "grow"}>
                      <DataTable className="custom-scrollbar" data={filteredItems} columns={ProductTableListHead} striped highlightOnHover pagination selectableRows subHeader subHeaderComponent={subHeaderComponentMemo} />
                    </StyleSheetManager>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default ProductListContainer;